import { colors } from 'fitify-ui'
import { biggerPhone } from 'fitify-ui-landing/src/theme/breakpoints'
import { css, styled } from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 40px 48px;
  border-radius: 24px;
  background-color: ${colors.Black};
  gap: 24px;

  ${biggerPhone(css`
    flex-direction: column;
    padding: 32px 24px;
    text-align: center;
  `)};
`

export const StyledContent = styled.div`
  display: flex;
  max-width: 480px;
  flex-direction: column;
  gap: 8px;
`
